import React, { useState, useEffect } from "react";
import { IconButton } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";

const FullscreenToggle = () => {
  const [isFullscreen, setIsFullscreen] = useState(
    JSON.parse(sessionStorage.getItem("isFullscreen")) || false
  );

  useEffect(() => {
    const handleFullscreenChange = () => {
      const isCurrentlyFullscreen = !!document.fullscreenElement;
      setIsFullscreen(isCurrentlyFullscreen);
      sessionStorage.setItem("isFullscreen", JSON.stringify(isCurrentlyFullscreen));
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const handleToggleFullscreen = () => {
    const elem = document.documentElement;
    if (!isFullscreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  return (
    <IconButton onClick={handleToggleFullscreen} sx={{ width: "24px" }}>
      {isFullscreen ? <FullscreenExitIcon sx={{ width: "26px", height: "26px", color: "black" }} /> : <FullscreenIcon sx={{ width: "26px", height: "26px", color: "black" }} />}
    </IconButton>
  );
};

export default FullscreenToggle;
